import { useEffect } from 'react';
import useUserSession from '@src/hooks/useUserSession';
import * as Sentry from '@sentry/react';

const SentryProvider = () => {
    const { user: sessionUser } = useUserSession();

    useEffect(() => {
        if (!sessionUser?.id) return;

        Sentry.setUser({
            id: sessionUser.id,
            email: sessionUser.user_email,
        });
    }, [sessionUser]);

    return null;
};

export default SentryProvider;
